import { CheckCircle2,Tag  } from "lucide-react";
import SectionHead from "./SectionHead";

export default function Pricing({ pricing, scrollToForm }) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHead eyebrow={pricing.eyebrow} title={pricing.title} sub={pricing.subtitle} />
        <div className="grid grid-cols-1 gap-6 max-w-3xl mx-auto md:grid-cols-2">

          {/* Price */}
          <div className="dc-price-card">
            <div className="dc-price-dots" />
            <div className="relative">
              <div className="text-xs font-bold uppercase tracking-widest mb-5" style={{ color: "rgba(255,255,255,0.6)" }}>
                {pricing.priceLabel}
              </div>
              <del className="text-white flex items-center gap-1 "><Tag className="w-4 h-4"/>{pricing.priceOriginal} {pricing.priceCurrency}</del>
              <div className="font-extrabold text-white mb-1" style={{ fontSize: 52, letterSpacing: -3, lineHeight: 1 }}>
                {pricing.priceAmount}{" "}
                <span className="text-lg font-bold" style={{ color: "rgba(255,255,255,0.7)" }}>{pricing.priceCurrency}</span>
              </div>
              <div className="text-sm mb-7" style={{ color: "rgba(255,255,255,0.6)" }}>{pricing.pricePeriod}</div>
              
              <button onClick={scrollToForm}
                className="w-full bg-white font-extrabold py-3.5 rounded-xl text-sm transition-all hover:-translate-y-0.5 hover:shadow-xl"
                style={{ color: "#7c3aed" }}>
                {pricing.priceCta} →
              </button>
              <div className="text-center text-xs mt-3" style={{ color: "rgba(255,255,255,0.5)" }}>
                {pricing.priceNote}
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="rounded-3xl p-9" style={{ background: "#f8f8fb", border: "1.5px solid #ede9fe" }}>
            <div className="font-extrabold text-gray-900 mb-5">{pricing.featuresTitle}</div>
            <div className="flex flex-col gap-3">
              {pricing.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-3 text-sm text-gray-700">
                  <CheckCircle2 size={18} className="text-violet-500 flex-shrink-0" strokeWidth={2.5} />
                  {feat}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}